import React, { Component, Fragment } from 'react';

import ModalDetailsStoreLocation from './ModalStoreLocation/ModalDetailsStoreLocation';
import ModalStoreLocation from './ModalStoreLocation/ModalStoreLocation';
import ModalAllStates from './ModalStoreLocation/ModalAllStates';
import StoreLocationBtn from './StoreLocationBtn';
import NewDropDown from './NewHeaderWeb/NewDropdown';
import Overlay from './Overlay';
import serverClientUtil from '../../../utils/serverClientUtil';

import commonUtil from '../../../utils/commonUtil';
import { mapMarkerIcon } from './svgIcons';

const constChannels = commonUtil.getClientConstForChannel();
const channel = commonUtil.getChannel();
class NewHeaderTop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredIndex: null,
      isLastHovered: false,
      shouldShowModalDetails: {
        storeName: '',
        schedule: '',
        address: {},
        storeId: '',
        services: '',
      },
    };
  }

  handleHover = (index) => this.setState({ hoveredIndex: index });
  handleLeave = () => this.setState({ hoveredIndex: null });

  handleOnHoverServicesBtn = (statusHover) =>
    this.setState({ aboveServicesButton: statusHover });

  handleOnHoverOtherSitesBtn = (statusHover) =>
    this.setState({ aboveOtherSitesButton: statusHover });

  handleModalDetails = ({
    storeName,
    address,
    storeId,
    services,
    schedule,
  }) => {
    this.setState({
      ...this.state,
      shouldShowModalDetails: {
        storeName,
        address,
        storeId,
        services,
        schedule,
      },
    });
  };

  render() {
    // * From HeaderTopContainer
    const {
      showModalLocationContent,
      showModalLocationContentUpdate,
      showModalStates,
      showModalStatesUpdate,
      showModalDetails,
      showModalDetailsUpdate,

      storesForZip,
      storesForState,
      storeOrCityOrStateName,

      // * Functions
      hideOverlay,
      callForSearchStores,
      callSearchZipStateService,
      stateOrZipSelectedUpdate,
    } = this.props;

    // * From Header container
    const {
      home,
      services,
      linksHeaderTop,
      otherSites,
      storeLocationStates,
      storeByNear,
      requiredLabel,
      storeNearSelected,
    } = this.props;

    const { links: itemsHeaderTop } = linksHeaderTop || {};
    // console.log('itemsHeaderTop', itemsHeaderTop);
    const getAllStatesOfCountry = storeLocationStates.data;

    const {
      aboveServicesButton,
      aboveOtherSitesButton,
      shouldShowModalDetails,
    } = this.state;
    
    const lastIndex = itemsHeaderTop?.length - 1;

    return (
      <div className='wrapHeaderTop'>
        <div className='headerTopContainer centerHeader'>
          <section className='borderRight' style={{ display: 'none' }}>
            <div className='itemLink'>
              {mapMarkerIcon}
              <a
                className='item rightTopMenu'
                href='https://dtaqa.suburbia.com.mx/tienda/home'
              >
                Mi direccion
              </a>
            </div>
            <div className='itemLink'>
              <a
                className='item rightTopMenu regularFont'
                href='https://dtaqa.potterybarn.com.mx/tienda/home'
              >
                C.P. 03840
              </a>
            </div>
          </section>

          <StoreLocationBtn
            showModalLocationContentUpdate={showModalLocationContentUpdate}
            storeNearSelected={storeNearSelected}
          />

          {channel === constChannels.WEB && (
            <Fragment>
              {itemsHeaderTop?.map((item, index) => {
                const hasDropdown = item.items && item.items.length > 0;
                const isHovered = this.state.hoveredIndex === index;
                const isMesaDeRegalos = item.label === 'Mesa de regalos';
                const isLastItem = index === lastIndex;

                return (
                  <div
                    key={item.uid}
                    className={`itemLink ${
                      hasDropdown
                        ? 'headerTopRightSection dinamicItemContainerForDropdown'
                        : isMesaDeRegalos
                          ? 'link-default-active'
                          : ''
                    }`}
                    style={{
                      borderRight: isLastItem ? 'none': '1px solid white',
                    }}
                    onMouseEnter={() => hasDropdown && this.handleHover(index)}
                    onMouseLeave={() => hasDropdown && this.handleLeave()}
                  >
                    {hasDropdown ? (
                      <div className='dropdownsHeaderTopContainer'>
                        <span
                          className='item dropdownHeaderTopBtn dropdownOtherSitesWidthBtn'
                          style={{ cursor: 'pointer', color: "#FAFAFA" }}
                        >
                          {item?.text || item?.label}
                        </span>
                        <span className='chevron bottom' />
                      </div>
                    ) : (
                      <a className='item' href={serverClientUtil.getNavUrl(item.url)}>
                        {item?.text || item?.label}
                      </a>
                    )}
                    {hasDropdown && isHovered && (
                      <NewDropDown
                        handleOnHoverBtn={() => this.handleHover(index)}
                        dataList={item?.items}
                      />
                    )}
                    {!hasDropdown && <span className='decoratorUndeline' />}
                  </div>
                );
              })}
            </Fragment>
          )}
        </div>

        {(aboveServicesButton ||
          aboveOtherSitesButton ||
          showModalLocationContent) && (
          <Overlay
            styles={{
              styleTop: `${showModalLocationContent ? 0 : '40px'}`,
              cursor: `${showModalLocationContent ? 'default' : 'cursor'}`,
              zIndex: 1,
            }}
          >
            <Fragment>
              {showModalLocationContent &&
                !showModalStates &&
                !showModalDetails && (
                  <ModalStoreLocation
                    hideOverlay={hideOverlay}
                    showModalStatesUpdate={showModalStatesUpdate}
                    showModalDetailsUpdate={showModalDetailsUpdate}
                    showModalLocationContent={showModalLocationContent}
                    storeLocationStates={storeLocationStates}
                    storeNearSelected={storeNearSelected}
                    callForSearchStores={callForSearchStores}
                    callSearchZipStateService={callSearchZipStateService}
                    storesForZip={storesForZip}
                    storesForState={storesForState}
                    // * For ModalAllStates functionality
                    stateSelected={storeOrCityOrStateName.stateSelected}
                    storeByNear={storeByNear}
                    requiredLabel={requiredLabel}
                    // * For modal details
                    handleModalDetails={this.handleModalDetails}
                  />
                )}

              {showModalStates && (
                <ModalAllStates
                  withReturn={showModalStatesUpdate}
                  stateOrZipSelectedUpdate={stateOrZipSelectedUpdate}
                  hideOverlay={hideOverlay}
                  data={getAllStatesOfCountry}
                />
              )}

              {showModalDetails && (
                <ModalDetailsStoreLocation
                  withReturn={showModalDetailsUpdate}
                  data={shouldShowModalDetails}
                  hideOverlay={hideOverlay}
                />
              )}
            </Fragment>
          </Overlay>
        )}
      </div>
    );
  }
}

export default NewHeaderTop;
